import { render, staticRenderFns } from "./ModalDenuncia.vue?vue&type=template&id=10e2cbe4&scoped=true&"
import script from "./ModalDenuncia.vue?vue&type=script&lang=js&"
export * from "./ModalDenuncia.vue?vue&type=script&lang=js&"
import style0 from "./ModalDenuncia.vue?vue&type=style&index=0&id=10e2cbe4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e2cbe4",
  null
  
)

export default component.exports